import { FunctionComponent, ReactNode } from "react";
import { Navigate } from "react-router";

import { AppRole } from "../../../../@api";

import { RouteConstants } from "../../../models/enums";
import { useStore } from "../../../stores/StoreContext";

interface IAdminAreaGuardProps {
  children: ReactNode;
}

export const AdminAreaGuard: FunctionComponent<IAdminAreaGuardProps> = props => {
  const { permissionStore } = useStore();

  if (
    !permissionStore.hasAnyRole([
      AppRole.LegalInformationAdmin,
      AppRole.UserManagementAdmin,
      AppRole.ContentManagementAdmin,
      AppRole.AppCustomizationAdmin,
      AppRole.GlossaryAdmin,
    ])
  ) {
    return <Navigate to={`/${RouteConstants.LandingPage}`} replace />;
  }

  return props.children;
};
